module.exports = __webpack_public_path__ + "img/email-send-outline.d83ddaa9.svg";